import { SmartCheckbox } from 'app/components/shared/FormComponents/SmartCheckbox'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { FormSection } from 'app/components/shared/FormSection'
import { Grid } from 'app/components/ui/Grid'
import React from 'react'
import { useFormContext } from 'react-hook-form'

export const SecondaryBankDetailsFormSection = (): JSX.Element => {
  const { watch, getValues, setValue } = useFormContext()

  const makeFieldName = (fieldName: string) => `bank_account_2.${fieldName}`

  const fillSecondaryBankAccountWatcher = watch('fill_secondary_bank_account')

  return (
    <>
      <FormSection title='Coordinate bancarie secondarie'>
        <FormGroup>
          <SmartCheckbox name='fill_secondary_bank_account'>
            Coordinate bancarie secondarie se diverse dalle precedenti
          </SmartCheckbox>
        </FormGroup>

        {fillSecondaryBankAccountWatcher && (
          <Grid cols={[4, 4, 4]}>
            <FormGroup>
              <SmartInput label='Banca' name={makeFieldName('bank')} />
            </FormGroup>
            <FormGroup>
              <SmartInput
                label='Agenzia / Filiale'
                name={makeFieldName('agency')}
              />
            </FormGroup>
            <FormGroup>
              <SmartInput
                label='IBAN'
                name={makeFieldName('iban')}
                onChange={() =>
                  setValue(
                    'bank_account_2.iban',
                    getValues('bank_account_2.iban').replace(/\s/g, '')
                  )
                }
              />
            </FormGroup>
          </Grid>
        )}
      </FormSection>
      {fillSecondaryBankAccountWatcher && (
        <>
          <FormSection title='Persona delegata ad operare sul CC secondario'>
            <Grid cols={[6, 6]}>
              <FormGroup>
                <SmartInput
                  label='Nome'
                  name={makeFieldName('delegated_name')}
                />
              </FormGroup>
              <FormGroup>
                <SmartInput
                  label='Cognome'
                  name={makeFieldName('delegated_surname')}
                />
              </FormGroup>
            </Grid>
            <Grid cols={[6, 6]}>
              <FormGroup>
                {' '}
                <SmartInput
                  label='Codice Fiscale'
                  name={makeFieldName('delegated_fiscal_code')}
                />
              </FormGroup>
              <FormGroup>
                {' '}
                <SmartInput
                  label='Ruolo'
                  name={makeFieldName('delegated_role')}
                />
              </FormGroup>
            </Grid>
          </FormSection>
        </>
      )}
    </>
  )
}
